// ============================================================================
// API - componentLibraryAPI.js
// ============================================================================
// client/src/api/componentLibraryAPI.js

import axiosInstance from '../utilities/axiosInstance';

const componentLibraryAPI = {

  // Get all active components
  getAllComponents: async () => {
    try {
      const response = await axiosInstance.get('/api/component-library');
      return response.data;
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to get components: ${error.message}` 
      };
    }
  },

  // Get components by category
  getComponentsByCategory: async (category) => {
    try {
      const response = await axiosInstance.get(`/api/component-library/category/${category}`);
      return response.data;
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to get components by category: ${error.message}` 
      };
    }
  },
 
  getComponentById: async (componentId) => {
    try {
      const response = await axiosInstance.get(`/api/component-library/${componentId}`);
      return response.data;
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to get component: ${error.message}` 
      };
    }
  },

  // Create component
  createComponent: async (componentData) => {
    try {
      const response = await axiosInstance.post('/api/component-library', componentData);
      return response.data;
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to create component: ${error.message}` 
      };
    }
  },

  // Update component
  updateComponent: async (componentId, updateData) => {
    try {
      const response = await axiosInstance.put(`/api/component-library/${componentId}`, updateData);
      return response.data;
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to update component: ${error.message}` 
      };
    }
  },

  // Delete component
  deleteComponent: async (componentId) => {
    try {
      const response = await axiosInstance.delete(`/api/component-library/${componentId}`);
      return response.data;
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to delete component: ${error.message}` 
      };
    }
  },

  // Search components
  searchComponents: async (searchTerm) => {
    try {
      const response = await axiosInstance.get('/api/component-library/search', {
        params: { q: searchTerm }
      });
      return response.data;
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to search components: ${error.message}` 
      };
    }
  },

  // Check duplicates before bulk import
  checkDuplicates: async (category) => {
    try {
      const response = await axiosInstance.post('/api/component-library/check-duplicates', {
        category
      });
      return response.data;
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to check duplicates: ${error.message}` 
      };
    }
  },

  // Bulk import components by category
  bulkImportComponents: async (category, shouldUpdate = false, createdBy) => {
    try {
      const response = await axiosInstance.post('/api/component-library/bulk-import', {
        category,
        shouldUpdate,
        createdBy  // ✅ Send createdBy in body
      });
      return response.data;
    } catch (error) {
      return error?.response?.data || { 
        success: false, 
        error: `Failed to bulk import components: ${error.message}` 
      };
    }
  },

  /**
   * Validate component configuration
   * Calls backend validateComponentConfiguration method
   * @param {string} componentId - Component library ID (from componentLibrary collection)
   * @param {Object} instanceConfig - Component instance configuration to validate
   * @returns {Promise<{success: boolean, data?: {valid: boolean, errors: [], warnings: []}, error?: string}>}
   */
  validateComponentConfiguration: async (componentId, instanceConfig) => {
    try {

      console.log('🔍 ============================================');
    console.log('🔍 API: Making validation request');
    console.log('🔍 URL:', `/api/component-library/${componentId}/validate-config`);
    console.log('🔍 Component ID:', componentId);
    console.log('🔍 Config being sent:', instanceConfig);
    console.log('🔍 ============================================');

      const response = await axiosInstance.post(
        `/api/component-library/${componentId}/validate-config`,
        instanceConfig  // Send the entire config as body
      );
      console.log('✅ API Response received:', response.data);
      return response.data;
    } catch (error) {
      console.error('❌ API Error:', error);
      return error?.response?.data || { 
        success: false, 
        error: `Failed to validate component configuration: ${error.message}` 
      };
    }
  },


};

export default componentLibraryAPI;